// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uNdZm","field":"styles_field__2zgs7","fieldCol":"styles_fieldCol__2Vj0o","diffCol":"styles_diffCol__1Yav2","diff":"styles_diff__mqTQn"};